import httpClient from '../httpClient';

const post = async (data) => {
	return await httpClient.post(`${process.env.REACT_APP_API_HOST}/organization_partner/`, data);
};

const getAll = async () => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/organization_partner/`);
};

const getAllByID = async (id) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/organization_partner/?filter[organizacion]=${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`${process.env.REACT_APP_API_HOST}/organization_partner/${id}/`, data);
};

const patch = async (id) => {
  return await httpClient.patch(`${process.env.REACT_APP_API_HOST}/organization_partner/${id}`);
};

const remove = async (id) => {
  return await httpClient.delete(`${process.env.REACT_APP_API_HOST}/organization_partner/${id}`);
};

export {
  post,
  getAll,
  getAllByID,
  put,
  patch,
  remove
};
